import React from "react";
import ReactDOM from "react-dom";

const Modal = props => {
    const domEl = document.getElementById("modal-root");
    if (!domEl) return false;

    // Modal div will be rendered into 'modal-root' div, no matter where this component is used in the tree
    return ReactDOM.createPortal(
        <div className="modal-container" key="modal-container">
            <div className="modal-subcontainer">
                {props.closable && !props.hideCloseButton && (
                    <button className="modal__close button" onClick={props.closeModal}>close</button>
                )}
                <div className="modal">
                    {props.children}
                </div>
            </div>
        </div>,
        domEl
    );
};

export default Modal;